import * as constants from "./constants";

/**
 * 修改注册信息
 */
export const saveRegisterInfo = (data: any) => {
  return {
    type: constants.SAVE_REGISTER_INFO,
    payload: data,
  };
};
